import React, { useEffect } from 'react';

import { getPrecisionOptions, getRollupPrecision } from 'src/helpers/metrics';
import { Select } from 'src/components/matchbox';
import { roundBoundaries } from '@sparkpost/report-builder/helpers/date';
import { formatISO } from 'date-fns';

const PrecisionSelector = ({ from, to, changeTime, selectedPrecision, disabled, ready }) => {
  const precisionOptions = getPrecisionOptions(from, to);

  useEffect(() => {
    if (from && to && selectedPrecision) {
      const updatedPrecision = getRollupPrecision({ from, to, precision: selectedPrecision });
      if (updatedPrecision !== selectedPrecision && ready) {
        //Bug showed up during unit tests, wasn't showing up in actual page though.
        changeTime({ precision: updatedPrecision });
      }
    }
  }, [changeTime, from, precisionOptions, selectedPrecision, to, ready]);

  const updatePrecision = ({ currentTarget: { value: precision } }) => {
    const { from: roundedFrom, to: roundedTo } = roundBoundaries({
      from: formatISO(from),
      to: formatISO(to),
      precision
    });

    changeTime({ from: roundedFrom, to: roundedTo, precision });
  };

  return (
    <Select
      data-id="precision-selector"
      id="precision-selector"
      options={precisionOptions}
      onChange={updatePrecision}
      value={selectedPrecision}
      label="Precision"
      disabled={disabled}
    />
  );
};

export default PrecisionSelector;
